import sessionStore from 'owa-session-store/lib/store/store';
import { makePostRequest } from 'owa-ows-gateway';

const DEFAULT_MAX_RESULTS = 5;
const WEATHERLOCATIONSUGGESTIONS_ENDPOINT_URL = 'ows/beta/WeatherLocation/suggestions';

/**
 * Performs findWeather suggestions request
 * @param queryString: The string to search
 * @param maxResults: the max number of results requested by the caller
 * @param meetingTimeSlot: the meeting time, used by the ranker for more relevant results
 * @param coordinates: the client's geo-coordinates, used by bing for more relevant results
 */
export default async function findWeatherLocations(
    queryString: string,
    maxResults: number,
    coordinates: GeolocationCoordinates
): Promise<Response> {
    let request = {
        query: queryString,
        maxResults: maxResults >= 0 ? maxResults : DEFAULT_MAX_RESULTS,
        culture: sessionStore.userConfiguration.SessionSettings.UserCulture,
        latitude: coordinates ? coordinates.latitude : null,
        longitude: coordinates ? coordinates.longitude : null,
    };

    return makePostRequest(WEATHERLOCATIONSUGGESTIONS_ENDPOINT_URL, request, undefined, true);
}
